'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isCampaignScore = (score) => 'campaignId' in score;
const isWikiScore = (score) => 'wikiId' in score;
const isBattleScore = (score) => 'battleId' in score;

exports.isBattleScore = isBattleScore;
exports.isCampaignScore = isCampaignScore;
exports.isWikiScore = isWikiScore;
//# sourceMappingURL=score.js.map
